import React from "react";
import { motion } from "framer-motion";

/**
 * Editorial pull-quote — used as a cinematic pause between sections.
 * Large display weight, narrow column, gold accent rule.
 */
export default function PullQuote({ children, attribution, className = "" }) {
  return (
    <motion.figure
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
      className={`relative max-w-4xl mx-auto text-center ${className}`}
      data-testid="pull-quote"
    >
      <div className="mx-auto mb-10 h-px w-20 bg-gradient-to-r from-transparent via-gold to-transparent" />
      <blockquote className="font-display-tight text-white text-[clamp(1.75rem,3.4vw,3rem)] leading-[1.15] tracking-[-0.035em] font-extralight">
        {children}
      </blockquote>
      {attribution && (
        <figcaption className="mt-10 font-mono text-[0.62rem] text-ag-text-muted tracking-[0.32em] uppercase">
          {attribution}
        </figcaption>
      )}
      <div className="mx-auto mt-10 h-px w-20 bg-gradient-to-r from-transparent via-gold to-transparent" />
    </motion.figure>
  );
}
